import styled from 'styled-components';

export const Container = styled.div`
  .modal-body {
    overflow: auto;
  }
  .tableContainer {
    div {
      overflow: hidden;
    }
  }
`;

export const Content = styled.div`
  width: 100%;

  h2 {
    color: var(--purple);
    margin-bottom: 7px;
    font-size: 1.3rem;
  }
  div {
    margin-top: 5px;
    margin-bottom: 10px;
    font: 400 1rem 'Source Sans Pro', sans-serif;
  }
`;
